import { ActionType } from 'typesafe-actions';
import { ISubscriptionData } from './models';
import * as actions from './actions';

export interface ISubscriptionState {
	readonly data: ISubscriptionData[];
	readonly loading: boolean;
	readonly error?: string;
}

export type SubscriptionsAction = ActionType<typeof actions>;

const initialState: ISubscriptionState = {
	data: [],
	loading: false,
};

const reducer = (state: ISubscriptionState = initialState, action: any) => {
	switch (action.type) {
		case actions.FETCH_SUBSCRIPTIONS_INIT:
			return { ...state, loading: true };
		case actions.FETCH_SUBSCRIPTIONS_SUCCESS:
			return { ...state, loading: false, data: action.subscriptions };
		case actions.FETCH_SUBSCRIPTIONS_FAILURE:
			return { ...state, loading: false, error: action.error };
		default:
			return state;
	}
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/modules/subscriptions/reducer.ts